
const mayBeANodeTargeted = (bqnId, command) =>
  bqnId === null || bqnId === undefined
  ? command
  : command + ` bqn-id ${bqnId}`;

export const composeCommand = (
  { strategy, filePath, bqnId = null }
) =>
  mayBeANodeTargeted(
    bqnId,
    `api storage load file ${filePath} ${strategy}`
  )
  
export const composeFlushCommand = (
  { bqnId = null }
) =>
  mayBeANodeTargeted(
    bqnId,
    'api storage write flush'
  )
 
const thereAreErrors = (input) => {
  const match = input.match(/\((\d+)\serrors\)/);
  if (match === null) {
    return false;
  }
  const [_all, counter] = match;
  return counter !== "0";
};

export const checkWarnings = (response) => {
  let match = null;
  const warningExpr = /,?%(WARN|ERR-ENOENT):\s([^\n]+)/g;
  while ((match = warningExpr.exec(response))) {
    const [all, type, message] = match;
    if (type === 'ERR-ENOENT' || thereAreErrors(message)) {
      throw message;
    }
    response = response.replace(all, "");
  }
  return response;
};
  
const extractBrief = input =>
  Object.fromEntries(
    Array.from(
      input.matchAll(/([\w-]*)\(([\w.]*)\)\s?/g),
      ([, key, value]) => [key, value]
    )
  )

const formatTime = input =>
  ((seconds) => isNaN(seconds)
    ? ''
    : ' in ' + seconds.toFixed(3) + 's')(Number(input));

export const formatResult = result => {
  if (typeof result !== 'string' || !result.includes(':')) {
    return result;
  }
  const [total, brief] = result.split(/:\s+/);
  const {
    policies = 'unknown',
    ['subscriber-groups']: subscriberGroups = 'unknown',
    subscribers = 'unknown',
    time = 'unknown',
  } = extractBrief(brief)
  return [
    `${total}${formatTime(time)}:`,
    `  ${policies} policies`,
    `  ${subscribers} subscribers`,
    `  ${subscriberGroups} subscriber groups`,
  ].join('\n');
}
